import axiosInstance from './axiosInstance';

export const login = (email, password) => {
  return axiosInstance.post('/api/auth/login', { username: email, password });
};

export const logout = () => {
  return axiosInstance.post('/api/auth/logout');
};

export const generateOTP = async (emailId, newPassword, confirmPassword) => {
  const response = await axiosInstance.post('/api/auth/generateOTP', {
    emailId,
    newPassword,
    confirmPassword,
    otp: 0
  });
  return response.data;
};

export const verifyOTP = async (emailId, newPassword, confirmPassword, otp) => {
  const response = await axiosInstance.post('/api/auth/verifyOTP', {
    emailId,
    newPassword,
    confirmPassword,
    otp: parseInt(otp)
  });
  return response.data;
};

// -----------------------------------Start Add new code for token handler -----------------------------------

export const loginWithToken = (token) => {
  return axiosInstance.post('/api/auth/login', {}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

// -----------------------------------End Add new code for token handler -----------------------------------
